export const accessCodesQueryKey = (lockboxId: number) => [
  "LOCKBOXES",
  "ACCESS_CODES",
  lockboxId
];
